import React from 'react';
export function EmotionSection() {
  const points = [{
    title: 'Your follicles, reawakened.',
    description: "Dormant hair brought back with your body's own growth factors."
  }, {
    title: 'Volume you can feel.',
    description: 'The difference in thickness you notice every morning.'
  }, {
    title: 'Confidence, restored.',
    description: "Because hair isn't vanity. It's identity."
  }];
  return <section className="bg-cream py-20 md:py-32 px-4" data-id="element-64">
      <div className="max-w-7xl mx-auto" data-id="element-65">
        <h2 className="font-serif text-3xl md:text-5xl text-espresso text-center mb-16 md:mb-24" data-id="element-66">
          Thicker. Fuller. Yours.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 lg:gap-16" data-id="element-67">
          {points.map((point, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-68">
              <span className="text-gold text-2xl mb-6 transform transition-transform group-hover:scale-110" aria-hidden="true" data-id="element-69">
                ✦
              </span>
              <h3 className="font-serif italic text-2xl md:text-3xl text-espresso mb-4" data-id="element-70">
                {point.title}
              </h3>
              <p className="font-sans text-base md:text-lg text-muted-foreground leading-relaxed max-w-sm" data-id="element-71">
                {point.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}